module.exports = __webpack_public_path__ + "static/media/continuousDiscourse_RL.3ff14b7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/calibration/continuousDiscourse_RL.mp3
// module id = vXKz
// module chunks = 1